<div class="sheet">

  <div class="header">
    <div>
      <h3>{{ 'PAY_AT_TABLE.SPLIT_TITLE' | translate }}</h3>
      <span>{{ 'PAY_AT_TABLE.SPLIT_SUBTITLE' | translate }}</span>
    </div>

    <div (click)="close()" aria-label="Close">
      <img class="icon-xl" [src]="'close.svg' | themeSource" alt="close" />
    </div>
  </div>

  <div class="options">
    @for (opt of options; track opt.key) {
      <button type="button" class="btn option" (click)="pick(opt.key)">
        {{ opt.labelKey | translate }}
      </button>
    }
  </div>

</div>
